const CASE = 'patient';
const EMPLOYER = 'provider';
const ONCALL = 'oncall';

module.exports = {
  CASE,
  EMPLOYER,
  ONCALL,
};
